// src/components/ui/SectionTitle.jsx — fixed v8.3
// Accepts both <SectionTitle title="..." /> and <SectionTitle>text</SectionTitle>
export default function SectionTitle({ title, children, subtitle }) {
  const text = title ?? children;
  return (
    <div style={{ marginBottom: 12 }}>
      <h2 style={{
        fontFamily: "var(--font-mono)",
        fontSize: 10,
        fontWeight: 400,
        letterSpacing: "0.16em",
        textTransform: "uppercase",
        color: "var(--text-tertiary)",
      }}>
        {text}
      </h2>
      {subtitle && (
        <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 2 }}>{subtitle}</div>
      )}
    </div>
  );
}
